// eslint-disable-next-line no-shadow
export enum LeadStep {
	emailStep = 'emailStep',
	personalInformationStep = 'personalInformationStep',
	addressStep = 'addressStep',
	phoneStep = 'phoneStep',
	phoneValidationStep = 'phoneValidationStep',
	financialInformationStep = 'financialInformationStep',
}

export const LEAD_STEPS_ORDER: LeadStep[] = [
	LeadStep.emailStep,
	LeadStep.personalInformationStep,
	LeadStep.addressStep,
	LeadStep.phoneStep,
	LeadStep.phoneValidationStep,
	LeadStep.financialInformationStep,
];

export const LeadStepValues: { [key in LeadStep]: string } = {
	[LeadStep.emailStep]: 'Primer paso',
	[LeadStep.personalInformationStep]: 'Información personal',
	[LeadStep.addressStep]: 'Dirección',
	[LeadStep.phoneStep]: 'Información de contacto',
	[LeadStep.phoneValidationStep]: 'Validación telefónica',
	[LeadStep.financialInformationStep]:
		'Validación de ingresos y dependientes economicos',
};

// eslint-disable-next-line no-shadow
export enum LeadStatus {
	inProgress = 'inProgress',
	completed = 'completed',
	expired = 'expired',
}

export type LeadStatusColor = 'yellow_100' | 'green_300' | 'red_300';

export const LeadStatusValues: {
	[key in LeadStatus]: { title: string; color: LeadStatusColor };
} = {
	[LeadStatus.inProgress]: { title: 'En progreso', color: 'yellow_100' },
	[LeadStatus.completed]: { title: 'Completado', color: 'green_300' },
	[LeadStatus.expired]: { title: 'Expirado', color: 'red_300' },
};

// eslint-disable-next-line no-shadow
export enum LeadSortType {
	createdAtNewer = '-createdAt',
	createdAtOlder = 'createdAt',
	updatedAtNewer = '-updatedAt',
	updatedAtOlder = 'updatedAt',
}

export const LeadSortValues: { [key in LeadSortType]: { title: string } } = {
	[LeadSortType.createdAtNewer]: { title: 'Creados más recientes' },
	[LeadSortType.createdAtOlder]: { title: 'Creados más antiguos' },
	[LeadSortType.updatedAtNewer]: { title: 'Actualizados más recientes' },
	[LeadSortType.updatedAtOlder]: { title: 'Actualizados más antiguos' },
};

export const getLeadProgressPercentage = (
	step: LeadStep,
	status: LeadStatus,
): number => {
	if (status === LeadStatus.completed) return 100;

	const index = LEAD_STEPS_ORDER.indexOf(step);
	if (index === -1) return 0;

	return Math.round((index / LEAD_STEPS_ORDER.length) * 100);
};
